export * from './confirm-delete-dialog/confirm-delete-dialog.model';
export { ConfirmDeleteDialogModule } from './confirm-delete-dialog/confirm-delete-dialog.module';
export * from './confirm-delete-dialog/confirm-delete-dialog.component';

export * from './historic-dates-dialog/historic-dates-dialog.model';
export { HistoricDatesDialogModule } from './historic-dates-dialog/historic-dates-dialog.module';
export * from './historic-dates-dialog/historic-dates-dialog.component';
